import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { NavigationExtras, Router } from '@angular/router';
import { Participant } from 'src/app/shared/models/Participant';
import { AuthenticationService } from 'src/app/_services';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { DatePipe } from '@angular/common';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { Constants } from 'src/app/shared/vo/Constants';

@Component({
  selector: 'app-shoolfpg-participant',
  templateUrl: './shoolfpg-participant.component.html',
  styleUrls: ['./shoolfpg-participant.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ShoolfpgParticipantComponent implements OnInit {

  /** GENERAL */
  date1: Date;
  cities: any[];
  value1: number;
  disabled: boolean;

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;

  /** REIDRECT */
  coordStoreId: String;
  schoolFpgDetail: any;
  listParticipant: any[];
  selectedParticipant: Participant;
  dataParent: any;
  datePipe: DatePipe = new DatePipe('en-US');

  lbl_part1: string;
  lbl_part2: string;

  /** LABELS */
  translations: Record<string, string> = {};

  displayModalStatus: boolean;
  displayModalGuide: boolean;
  commLetter: string = "0";

  /** STATUS MODAL */
  statusList: ValuesVO[]
  statusSelected: ValuesVO;
  dateSelected: string;
  commentsSelected: string;

  /** TRANSFER GUIDE MODAL */
  displayModalTransferGuide: boolean;

  /** SEND GUIDE MODAL */
  dateSentSelected: string;
  certifiedSelected: string;
  commentsSentSelected: string;

  participantSelected: any;
  fgChangesLog: { id: { key1Id: string; currDate: string; sequen: string; fileId: string; }; comments: string; }[];

  /**
   * This is a constructor function that initializes various services and checks for data passed through
   * navigation, redirecting if none is found.
   * @param {MessageService} messageService - A service that provides methods for displaying messages to
   * the user, such as success or error messages.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service provided
   * by the PrimeNG library that allows for displaying confirmation dialogs to the user. It can be used
   * to confirm actions before they are executed, such as deleting a record or submitting a form.
   * @param {ApiService} apiService - An instance of the ApiService class, which is likely used to make
   * HTTP requests to an API.
   * @param {Router} router - The router is a service provided by Angular that allows navigation between
   * different components and views in a single-page application. It is used to navigate to different
   * routes and pass data between them. In this constructor, the router is injected as a dependency and
   * is used to get the current navigation and extract any state data
   * @param {AuthenticationService} authenticationService - This parameter is likely a service that
   * handles user authentication and authorization. It may contain methods for logging in, logging out,
   * and checking user roles and permissions.
   * @param {TovpilUtilsService} tovpilUtils - tovpilUtils is a service that provides utility functions
   * for the TOVPIL application. It is likely used to perform common tasks such as formatting data,
   * validating input, or handling errors.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private translationService: TovpilLanguageService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService) {

    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    if (!this.dataParent) {
      this.redirectSchoolFG();
    }
  }

  /**
   * The ngOnInit function initializes component properties and retrieves security information.
   */
  ngOnInit(): void {
    if (this.dataParent) {
      this.security = this.dataParent.security;
      this.schoolFpgDetail = this.dataParent.eppg;
      this.coordStoreId = this.dataParent.storeId;

      this.getTranslatedLabels();
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
    this.getSecurity();
  }

  /**
   * This function redirects the user to the "workshops" page in a guide section.
   */
  redirectSchoolFG() {
    const delay = new Promise((resolve) => setTimeout(resolve, 1000));
    delay.then(() => {
      const navigationExtras: NavigationExtras = {
      };
      this.router.navigate(['catalogs/schoolfpg'], navigationExtras);
    });
  }

  /**
   * This function redirects to a participant detail page with relevant information.
   * @param {any} participantSel - The parameter `participantSel` is a variable that represents the
   * selected participant object. It is passed as an argument to the `redirectParticipantDetail`
   * function.
   */
  redirectParticipantDetail(participantSel: any) {
    let obj = {
      participant: participantSel,
      security: this.security,
      eppg: this.schoolFpgDetail
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['catalogs/eppgs/schoolfpgParticipantDetail'], navigationExtras);
  }

  /**
   * This function retrieves security information and loads participants.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;

          this.loadParticipants();

        });
    } else {
      this.loadParticipants();

    }
    this.changeDescription();
  }

  /**
   * This function loads participants for a specific workshop using an API service.
   */
  loadParticipants() {
    let params = {
      schoolId: this.schoolFpgDetail.schoolFPG.schoolId,
      language: this.schoolFpgDetail.schoolFPG.language
    }
    this.apiService.getListSchoolEnrollFGGuideAndAddress(params).then(
      participants => {

        this.listParticipant = participants;


      });
  }

  /**
   * The function `loadStatusChangesFG()` loads the historical changes for a specific school and
   * language.
   */
  loadStatusChangesFG() {
    let params = {
      fileId: "Guides",
      key1Id: this.participantSelected.guide.guideId
    }

    this.apiService.getListFgHistorialChanges(params).then(
      changes => {
        this.fgChangesLog = changes;
      });
  }

  /**
   * The function `convertDateFormat` takes a string in the format "YYYYMMDD" and returns a string in the
   * format "DD-MM-YYYY".
   * @param {string} originalDateStr - The originalDateStr parameter is a string representing a date in
   * the format "YYYYMMDD".
   * @returns a string in the format "day-month-year".
   */
  convertDateFormat(originalDateStr: string): string {
    if (!/^\d+$/.test(originalDateStr)) {
      return "Fecha no disponible";
    }

    const year = originalDateStr.substr(0, 4);
    const month = originalDateStr.substr(4, 2);
    const day = originalDateStr.substr(6, 2);

    return `${day}-${month}-${year}`;
  }

  /**
   * This function translations.lbl_confirmdisplays a confirmation message and deletes a participant if the user confirms the
   * action.
   * @param {any} participantSel - The parameter `participantSel` is likely an object or value that
   * represents the participant that the user wants to delete. It is passed as an argument to the
   * `deleteParticipant` function.
   */
  deleteParticipant(participantSel: any) {
    this.confirmationService.confirm({
      message: this.translations.lbl_are_you_sure + " " + this.translations.lbl_delete_record + " ?",
      header: this.translations.lbl_confirm + " " + this.translations.lbl_delete_record + " " + this.translations.lbl_participants,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteParticipantService(participantSel);
      }
    });
  }

  /**
   * This function deletes a participant from a workshop and displays a success or error message
   * accordingly.
   * @param {any} participantSel - The parameter `participantSel` is an object that represents the
   * selected participant to be deleted. It contains the properties `particiId`, `wrksId`, and
   * `language`.
   */
  deleteParticipantService(participantSel: any) {

    let guideAddr = {
      guide: participantSel.guide,
      address: participantSel.address,
    }
    let req = {
      schoolId: this.schoolFpgDetail.schoolFPG.schoolId,
      guideAddr: guideAddr,
      language: this.security.language,
      method: 'DELETE',
    }

    this.apiService.getCreateUpdateCancelSchoolEnrollFG(req).then(
      data => {
        if (data.status == 'OK') {
          this.loadParticipants();
          this.messageService.add({
            severity: 'success', summary: this.translations.lbl_updated_data, detail: '', life: 3000
          });

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorMessage, life: 9000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
      });
  }

  /**
   * The function retrieves translations for a list of labels and updates their values in the component.
   */
  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(this.security.language, this.security.region);
      this.translations = this.translationService.getLabels();
      // await this.getLanguages();
      // this.getLstCols();;
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }

  /**
   * The function changes the values of two variables.
   */
  changeDescription() {
    this.translations.lbl_part1 = this.translations.lbl_particp15s;
    this.translations.lbl_part2 = this.translations.lbl_participants_12;

  }

  /**
   * The exportExcel function checks if there is participant information available, and if so, it formats
   * the data and exports it to an Excel file.
   */
  exportExcel() {
    if (this.listParticipant === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.listParticipant.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.listParticipant.map((item) => ({
        "NOMBRE": item.guide ? (item.guide.name || 'S/N') : 'S/N' + ' ' + item.guide ? (item.guide.lastName || 'S/N') : 'S/N',
        "TELEFONO": item.guide ? (item.guide.mobPhon || 'S/N') : 'S/N',
        "EMAIL": item.guide ? (item.guide.email || 'S/N') : 'S/N',
        "ESTATUS": item.guideStatus || 'S/N',
      }));


      this.filesService.tovpilExportXLSX(filteredJSON, 'listSchoolsParticipant_');

    }
  }

  /**
   * The exportPdf function checks if there is participant information available, then formats and
   * exports the data to a PDF file.
   */
  exportPdf() {
    if (this.listParticipant === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.listParticipant.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.listParticipant.map((item) => ({
        "NOMBRE": item.guide ? (item.guide.name || 'S/N') : 'S/N' + ' ' + item.guide ? (item.guide.lastName || 'S/N') : 'S/N',
        "TELEFONO": item.guide ? (item.guide.mobPhon || 'S/N') : 'S/N',
        "EMAIL": item.guide ? (item.guide.email || 'S/N') : 'S/N',
        "ESTATUS": item.guideStatus || 'S/N',
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listSchoolsParticipant_');

    }
  }

  /**
   * The function `showDialogStatus` initializes variables and loads status transition rules for a
   * selected participant before displaying a modal for status changes.
   * @param {any} participantSel - The `participantSel` parameter is used to pass the selected
   * participant to the `showDialogStatus` method. This parameter is of type `any`, which means it can
   * accept any data type. When this method is called, the selected participant will be assigned to the
   * `participantSelected` property, and
   */
  showDialogStatus(participantSel: any) {
    this.statusSelected = null;
    this.commentsSelected = null;
    this.dateSelected = this.tovpilUtils.dateToTovpilDateFormat(new Date());
    this.participantSelected = participantSel;
    this.getStatusTransitionRules();
    this.displayModalStatus = true;
    this.loadStatusChangesFG();
  }

  /**
   * The function `updateParticipantStatus` updates the status of a participant and displays success or
   * error messages accordingly.
   */
  updateParticipantStatus() {

    let params = {
      guideId: this.participantSelected.guide.guideId,
      newStatus: this.statusSelected.valueId,
      schoolId: this.schoolFpgDetail.schoolFPG.schoolId,
      quitDate: this.tovpilUtils.dateToTovpilDate2(this.dateSelected),
      comments: this.commentsSelected,
    }

    this.apiService.changeStatusGuide(params).then(
      data => {
        if (data.status == 'OK') {
          this.messageService.add({
            severity: 'success', summary: this.translations.lbl_updated_data, detail: ' ', life: 3000
          });
          this.redirectSchoolFG();
        } else {
          this.messageService.add({ severity: 'error', summary: 'schoolFpgChangeStatusGuide()', detail: data.errorMessage, life: 9000 });
        }
      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'schoolFpgChangeStatusGuide', detail: error, life: 3000 });
      });

    this.participantSelected = null;
    this.displayModalStatus = false;
  }

  /**
   * The function `redirectoToParticipantTransfer` asynchronously redirects to a specific page with navigation
   * extras based on the provided rowData.
   * @param {any} rowData - The `redirectoToParticipantTransfer` function is an asynchronous function that takes
   * `rowData` as a parameter. This function is responsible for redirecting to a specific location in
   * your application with certain navigation parameters.
   */
  async redirectoToParticipantTransfer(rowData: any) {
    try {

      // Query Params
      const queryParams = {
        storeId: this.coordStoreId ?? null,
        churchName: this.schoolFpgDetail.churchName ?? null,
        schoolId: this.schoolFpgDetail.schoolFPG.schoolId ?? null,
        guideId: rowData['guide']['guideId'] ?? null,
      };

      try {
        let stringRedirect = 'catalogs/eppgs/schoolfpgParticipantTransfer';

        // Navegas a la ruta deseada con queryParams y/o navigationExtras
        this.router.navigate([stringRedirect], { queryParams });
      } catch (navigationError) {
        console.error("An error occurred while navigating to coordination catalog details:", navigationError);
        this.messageService.add({ severity: 'warn', summary: "No se pudo navegar a la opcion deseada", detail: Constants.FAILED_MESSAGE, life: 5000 });
      }
    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      this.messageService.add({ severity: 'warn', summary: "No se pudo navegar a la opcion deseada", detail: Constants.FAILED_MESSAGE, life: 5000 });
    }
  }

  /**
   * The function `showDialogGuide` resets certain variables and sets the `participantSelected` variable
   * before displaying a modal guide.
   * @param {any} participantSel - The parameter `participantSel` in the `showDialogGuide` function is
   * used to pass the selected participant to the function. This parameter is then used to set the
   * `participantSelected` property in the function, which is likely used to display information or
   * perform actions related to the selected participant.
   */
  showDialogGuide(participantSel: any) {
    this.commLetter = "0";
    this.dateSentSelected = null;
    this.certifiedSelected = null;
    this.commentsSentSelected = null;
    this.participantSelected = participantSel;
    this.displayModalGuide = true;
  }

  /**
   * This function updates the participant guide information for a school in a TypeScript application.
   */
  updateParticipantGuide() {

    let params = {
      schoolId: this.schoolFpgDetail.schoolFPG.schoolId,
      guideId: this.participantSelected.guide.guideId,
      certif: this.certifiedSelected,
      commLetter: this.commLetter,
      sendDate: this.tovpilUtils.dateToTovpilDate2(this.dateSentSelected),
      comments: this.commentsSentSelected,
      language : this.security.language
    }

    this.apiService.schoolFpgSendGuide(params).then(
      data => {
        if (data.status == 'OK') {
          this.messageService.add({
            severity: 'success', summary: this.translations.lbl_updated_data, detail: ' ', life: 3000
          });
          this.participantSelected = null;
          this.displayModalGuide = false;
          this.redirectSchoolFG();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorMessage, life: 9000 });
        }
      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
      });


  }

  /**
   * The function `getStatusTransitionRules` retrieves status transition rules from an API service and
   * sets the status list and selected status based on the response data.
   */
  getStatusTransitionRules() {
    this.apiService.getStatusTransitionRules({
      "language": this.security.language,
      "fieldId": "FGquitType",
      "fieldVal": this.participantSelected.guide.status ? this.participantSelected.guide.status : "B"
    }).then(
      data => {
        this.statusList = data;
        if (!this.statusSelected || !this.statusSelected.valueId) {
          this.statusSelected = this.statusList[0];
        }
      });
  }

  /**
   * The function `openGuideFGDetail` navigates to a specific page with participant details using Angular
   * router.
   * @param {any} participantSel - The `participantSel` parameter is the selected participant that will
   * be passed to the `openGuideFGDetail` function.
   */
  openGuideFGDetail(participantSel: any) {

    let obj = {
      participant: participantSel,
      security: this.security,
      eppg: this.schoolFpgDetail
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['catalogs/eppgs/schoolfpgParticipantDetail'], navigationExtras);
  }
}
